import { call, put } from 'redux-saga/effects';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  internallyApproveFailure,
  internallyApproveSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { InternallyApproveRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { internallyApprove } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import { updateSubmissionLog } from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { approveTifdReportFromReturnSaga } from 'store/tifd/sagas/approveTifdReportSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* internallyApproveSaga(action: InternallyApproveRequestAction) {
  const approvedTifd: boolean = yield call(
    approveTifdReportFromReturnSaga,
    action
  );
  if (approvedTifd) return;

  try {
    let err: ApiError | null;
    const { dataLogId, reportUrl, mappingId } = action.payload;

    const response: ApiResponse = yield call(
      internallyApprove,
      dataLogId,
      reportUrl,
      mappingId
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };

    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.INTERNAL_APPROVED));

    yield put(internallyApproveSuccess());
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        'INTERNAL_APPROVED',
        dataLogId
      )
    );
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(internallyApproveFailure());
  }
}
